if(!customElements.get('gift-wrapping-content')) {
  customElements.define('gift-wrapping-content', class GiftWrappingContent extends HTMLElement {
    constructor() {
      super();

      this.noteKey = "Gift wrapping note";
      this.radio = this.querySelector('.gift-wrapping-content__radio');
      this.addButton = this.querySelector('.gift-wrapping-content__add-button');
      if(this.radio) {
        this.productForm = this.querySelector('product-form');
        this.onRadioChangeHandler = this.onRadioChange.bind(this);
        this.radio.addEventListener('change', this.onRadioChangeHandler);
      }
      
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');

      this.noteInput = document.querySelector('textarea.cart-gift-note__area');
      if(this.noteInput) {
        if(!this.dataset.lineItemsKey && this.noteInput.value) {
          this.removeNote();
        }
        this.onNoteChangeHandler = debounce(this.onNoteChange.bind(this), 300);
        this.noteInput.addEventListener('change', this.onNoteChangeHandler);
      }
      if(this.dataset.removeGiftWrapping) {
        return this.removeGiftWrappingFromCart();
      }
    }

    disconnectedCallback() {
      if(this.radio) {
        this.radio.removeEventListener('change', this.onRadioChangeHandler);
      }
      if(this.noteInput) {
        this.noteInput.removeEventListener('change', this.onNoteChangeHandler);
      }
    }

    onRadioChange(e) {
      if(e.isTrusted && e.target.checked) {
        // Radio button selected - remove all other gifts, then add this one
        this.removeAllOtherGifts().then(() => {
          this.addGiftWrappingToCart();
        });
      }
    }

    onNoteChange(event) {
      this.updateNote(event.target.value);
    }

    updateNote(value) {
      const body = JSON.stringify({ attributes: {
        [this.noteKey]: value
      }});
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }

    removeNote() {
      this.updateNote('');
    }

    removeAllOtherGifts() {
      // Get the variant ID of the current gift (the one being added)
      const form = this.productForm ? this.productForm.querySelector('form') : null;
      const variantIdInput = form ? form.querySelector('input[name="id"]') : null;
      const currentVariantId = variantIdInput ? variantIdInput.value : null;
      
      // Get the current line item key from cart drawer or main cart
      const contentInner = this.closest('.cart-drawer__footer__content-inner');
      const giftWrappingUpdater = this.closest('gift-wrapping-updater');
      const currentItemKey = contentInner ? contentInner.dataset.itemKey : (giftWrappingUpdater ? giftWrappingUpdater.dataset.itemKey : null);
      
      if(!currentItemKey) {
        console.log('No item key, skipping gift removal');
        return Promise.resolve();
      }
      
      console.log('Removing other gifts for line item:', currentItemKey, 'except variant:', currentVariantId);
      
      // Fetch cart to find all gift products
      return fetch('/cart.js')
        .then(res => res.json())
        .then(cartData => {
          // Find all gift products that contain this line item key
          const giftItems = cartData.items.filter(item => {
            if(!item.properties || !item.properties._line_item_keys) {
              return false;
            }
            const keys = item.properties._line_item_keys.split(',');
            return keys.includes(currentItemKey);
          });
          
          console.log('Found gift items for this line item:', giftItems);
          
          // Filter out the current gift variant
          const giftsToUpdate = giftItems.filter(item => 
            item.variant_id && item.variant_id.toString() !== currentVariantId
          );
          
          console.log('Gifts to remove this line item from:', giftsToUpdate);
          
          if(giftsToUpdate.length === 0) {
            console.log('No other gifts to remove for this line item');
            return Promise.resolve();
          }
          
          // For each gift, remove this line item's key
          const updatePromises = giftsToUpdate.map(item => {
            const keys = item.properties._line_item_keys.split(',');
            const updatedKeys = keys.filter(key => key !== currentItemKey);
            
            console.log('Updating gift:', item.variant_id, 'from keys:', keys, 'to:', updatedKeys);
            
            if(updatedKeys.length === 0) {
              // No more keys, remove the gift completely
              console.log('Removing gift completely:', item.key);
              const updates = {};
              updates[item.key] = 0;
              
              const sections = this.cart.getSectionsToRender().map((section) => section.id);
              const body = JSON.stringify({
                updates: updates,
                sections: sections,
                sections_url: window.location.pathname
              });
              
              return fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
                .then(response => response.text())
                .then(state => JSON.parse(state));
            } else {
              // Update with remaining keys and new quantity
              console.log('Updating gift keys to:', updatedKeys.join(','));
              return fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ 
                body: JSON.stringify({
                  id: item.key,
                  quantity: updatedKeys.length,
                  properties: {
                    _line_item_keys: updatedKeys.join(',')
                  }
                })
              }})
              .then(response => response.json());
            }
          });
          
          return Promise.all(updatePromises);
        })
        .catch(err => {
          console.error('Error removing other gifts:', err);
          return Promise.resolve();
        });
    }

    addGiftWrappingToCart() {
      if(this.productForm) {
        const form = this.productForm.querySelector('form');
        if(form) {
          // Get the item-key from the content-inner container (cart drawer) or gift-wrapping-updater (main cart)
          const contentInner = this.closest('.cart-drawer__footer__content-inner');
          const giftWrappingUpdater = this.closest('gift-wrapping-updater');
          const itemKey = contentInner ? contentInner.dataset.itemKey : (giftWrappingUpdater ? giftWrappingUpdater.dataset.itemKey : null);
          
          // Get the variant ID
          const variantIdInput = form.querySelector('input[name="id"]');
          const variantId = variantIdInput ? variantIdInput.value : null;
          
          if(!variantId) {
            console.error('No variant ID found');
            return;
          }
          
          // Fetch cart to check if this gift already exists
          fetch('/cart.js')
            .then(res => res.json())
            .then(cartData => {
              // Find if this gift variant already exists in cart
              const existingGift = cartData.items.find(item => 
                item.variant_id && item.variant_id.toString() === variantId
              );
              
              if(existingGift) {
                console.log('Gift already exists in cart, updating...', existingGift);
                // Gift already exists, update it
                this.updateExistingGift(existingGift, itemKey);
              } else {
                console.log('Gift does not exist, adding new...');
                // Gift doesn't exist, add new
                this.addNewGift(itemKey);
              }
            })
            .catch(err => {
              console.error('Error checking cart:', err);
              // Fallback to adding new
              this.addNewGift(itemKey);
            });
        }
      }
    }
    
    addNewGift(itemKey) {
      const form = this.productForm.querySelector('form');
      if(form) {
        // Ensure quantity is set to 1
        let quantityInput = form.querySelector('input[name="quantity"]');
        if(!quantityInput) {
          quantityInput = document.createElement('input');
          quantityInput.type = 'hidden';
          quantityInput.name = 'quantity';
          form.appendChild(quantityInput);
        }
        quantityInput.value = '1';
        
        if(itemKey) {
          // Add the hidden input with the item-key property
          let propertyInput = form.querySelector('input[name="properties[_line_item_keys]"]');
          if(!propertyInput) {
            propertyInput = document.createElement('input');
            propertyInput.type = 'hidden';
            propertyInput.name = 'properties[_line_item_keys]';
            form.appendChild(propertyInput);
          }
          propertyInput.value = itemKey; // Single key for new gift
        }
        
        console.log('Adding new gift with quantity 1 and key:', itemKey);
        
        // Submit the form to add to cart
        form.dispatchEvent(new Event('submit'));
      }
    }
    
    updateExistingGift(existingGift, newItemKey) {
      // Get existing line item keys
      const existingKeys = existingGift.properties && existingGift.properties._line_item_keys 
        ? existingGift.properties._line_item_keys.split(',') 
        : [];
      
      // Add new key if provided and not already present
      if(newItemKey && !existingKeys.includes(newItemKey)) {
        existingKeys.push(newItemKey);
      }
      
      // Quantity should equal the number of line items
      const newQuantity = existingKeys.length;
      
      console.log('Updating gift with keys:', existingKeys.join(','));
      console.log('New quantity:', newQuantity);
      
      this.addButton?.classList.add('loading');
      
      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ 
        body: JSON.stringify({
          id: existingGift.key,
          quantity: newQuantity,
          properties: {
            _line_item_keys: existingKeys.join(',')
          }
        })
      }})
      .then(response => response.json())
      .then(item => {
        console.log('Gift updated:', item);
        
        // Fetch sections for rendering
        const sections = this.cart.getSectionsToRender().map((section) => section.id);
        const sectionsUrl = `${window.location.pathname}?sections=${sections.join(',')}`;
        
        return fetch(sectionsUrl)
          .then(res => res.json())
          .then(sectionsData => {
            return {
              sections: sectionsData,
              item: item
            };
          });
      })
      .then(data => {
        console.log('Sections fetched:', data);
        
        // Re-render cart with sections
        if(this.cart && this.cart.renderContents) {
          this.cart.renderContents(data);
        }
        
        // Also dispatch the update event
        return fetch('/cart.js');
      })
      .then(res => res.json())
      .then(cartData => {
        document.dispatchEvent(new CustomEvent('afterUpdateQuantity', {
          detail: {
            source: 'gift-wrapping',
            cartData: cartData
          }
        }));
        this.addButton?.classList.remove('loading');
      })
      .catch(err => {
        console.error('Error updating gift:', err);
        this.addButton?.classList.remove('loading');
      });
    }

    removeGiftWrappingFromCart() {
      // Get the item-key from the content-inner container (cart drawer) or gift-wrapping-updater (main cart)
      const contentInner = this.closest('.cart-drawer__footer__content-inner');
      const giftWrappingUpdater = this.closest('gift-wrapping-updater');
      const itemKey = contentInner ? contentInner.dataset.itemKey : (giftWrappingUpdater ? giftWrappingUpdater.dataset.itemKey : null);
      
      // Fetch current cart data to find the gift to remove
      fetch('/cart.js')
        .then(res => res.json())
        .then(cartData => {
          const form = this.productForm ? this.productForm.querySelector('form') : null;
          const variantIdInput = form ? form.querySelector('input[name="id"]') : null;
          const giftVariantId = variantIdInput ? variantIdInput.value : null;
          
          if(itemKey && giftVariantId) {
            // Find the gift item with this variant
            const giftItem = cartData.items.find(item => 
              item.variant_id && item.variant_id.toString() === giftVariantId
            );
            
            if(giftItem && giftItem.properties && giftItem.properties._line_item_keys) {
              // Get the comma-separated keys
              const keys = giftItem.properties._line_item_keys.split(',');
              
              // Remove this specific item-key
              const updatedKeys = keys.filter(key => key !== itemKey);
              
              console.log('Removing key:', itemKey);
              console.log('Remaining keys:', updatedKeys);
              
              if(updatedKeys.length === 0) {
                // No more keys, remove the gift completely
                console.log('No more keys, removing gift completely');
                this.removeGiftCompletely(giftItem.key);
              } else {
                // Update with remaining keys
                console.log('Updating gift with remaining keys');
                this.updateGiftKeys(giftItem, updatedKeys.join(','));
              }
            }
          } else {
            // Remove all instances of this gift variant (general gift wrapping)
            const keys = this.dataset.lineItemsKey;
            if(keys) {
              let updates = {};
              keys.split(',').forEach((key) => {
                updates[key] = 0;
              });
              const sections = this.cart.getSectionsToRender().map((section) => section.id);
              const body = JSON.stringify({
                updates: updates,
                sections: sections,
                sections_url: window.location.pathname
              });
              this.addButton?.classList.add('loading');
              return fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
                .then(response => response.text())
                .then(state => {
                  const parsedState = JSON.parse(state);
                  this.cart.renderContents(parsedState, null, null);
                  document.dispatchEvent(new CustomEvent('afterUpdateQuantity', {detail: {
                    source: 'gift-wrapping',
                    cartData: parsedState
                  }}));
                });
            }
          }
        })
        .catch(e => {
          console.error('Error removing gift wrapping:', e);
        });
    }
    
    removeGiftCompletely(giftKey) {
      const updates = {};
      updates[giftKey] = 0;
      
      const sections = this.cart.getSectionsToRender().map((section) => section.id);
      const body = JSON.stringify({
        updates: updates,
        sections: sections,
        sections_url: window.location.pathname
      });
      
      this.addButton?.classList.add('loading');
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }})
        .then(response => response.text())
        .then(state => {
          const parsedState = JSON.parse(state);
          this.cart.renderContents(parsedState, null, null);
          document.dispatchEvent(new CustomEvent('afterUpdateQuantity', {detail: {
            source: 'gift-wrapping',
            cartData: parsedState
          }}));
          this.addButton?.classList.remove('loading');
        })
        .catch(e => {
          console.error('Error removing gift:', e);
          this.addButton?.classList.remove('loading');
        });
    }
    
    updateGiftKeys(giftItem, newKeys) {
      // Calculate new quantity based on number of keys
      const keysArray = newKeys.split(',');
      const newQuantity = keysArray.length;
      
      console.log('Updating gift keys to:', newKeys);
      console.log('New quantity:', newQuantity);
      
      this.addButton?.classList.add('loading');
      
      fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ 
        body: JSON.stringify({
          id: giftItem.key,
          quantity: newQuantity,
          properties: {
            _line_item_keys: newKeys
          }
        })
      }})
      .then(response => response.json())
      .then(item => {
        console.log('Gift keys updated:', item);
        
        // Fetch sections for rendering
        const sections = this.cart.getSectionsToRender().map((section) => section.id);
        const sectionsUrl = `${window.location.pathname}?sections=${sections.join(',')}`;
        
        return fetch(sectionsUrl)
          .then(res => res.json())
          .then(sectionsData => {
            return {
              sections: sectionsData,
              item: item
            };
          });
      })
      .then(data => {
        console.log('Sections fetched for keys update:', data);
        
        // Re-render cart with sections
        if(this.cart && this.cart.renderContents) {
          this.cart.renderContents(data);
        }
        
        // Also dispatch the update event
        return fetch('/cart.js');
      })
      .then(res => res.json())
      .then(cartData => {
        document.dispatchEvent(new CustomEvent('afterUpdateQuantity', {
          detail: {
            source: 'gift-wrapping',
            cartData: cartData
          }
        }));
        this.addButton?.classList.remove('loading');
      })
      .catch(err => {
        console.error('Error updating gift keys:', err);
        this.addButton?.classList.remove('loading');
      });
    }
  });
}

if(!customElements.get('gift-wrapping-updater')) {
  customElements.define('gift-wrapping-updater', class GiftWrappingContent extends HTMLElement {
    constructor() {
      super();

      this.onCartChangeHandler = this.onCartChange.bind(this);
      document.addEventListener('afterCartChanged', this.onCartChangeHandler);
      document.addEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('afterCartChanged', this.onCartChangeHandler);
      document.removeEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }

    onCartChange() {
      const sections = ["gift-wrapping-bubble","gift-wrapping-content"];
      if(this.dataset.isDrawer) {
        sections.push('gift-wrapping-bubble-number');
      }
      const sectionsStr = sections.join(',');
      fetch(window.location.pathname + `?sections=${sectionsStr}`)
      .then(res => res.json())
      .then(res => {
        const bubbleHtml = getInnerHtmlFromText(res['gift-wrapping-bubble'], '.gift-wrapping-bubble');
        document.querySelector('.gift-wrapping-bubble').innerHTML = bubbleHtml;
        this.innerHTML = getInnerHtmlFromText(res['gift-wrapping-content'], '.shopify-section');
        if(this.dataset.isDrawer) {
          const bubbleNumberHtml = getInnerHtmlFromText(res['gift-wrapping-bubble-number'], '.gift-wrapping-bubble-number');
          document.querySelector('.gift-wrapping-bubble-number').innerHTML = bubbleNumberHtml;
        }
      });
    }
  });
}

// Handle line item gift trigger clicks
document.addEventListener('DOMContentLoaded', function() {
  initLineItemGiftTriggers();
  updateAllLineItemGiftTitles();
});

// Re-initialize after cart updates
document.addEventListener('afterCartChanged', function() {
  initLineItemGiftTriggers();
  // Delay to ensure DOM is updated after sections are rendered
  setTimeout(() => {
    updateAllLineItemGiftTitles();
  }, 100);
});

document.addEventListener('afterUpdateQuantity', function() {
  initLineItemGiftTriggers();
  // Delay to ensure DOM is updated after sections are rendered
  setTimeout(() => {
    updateAllLineItemGiftTitles();
  }, 100);
});

function initLineItemGiftTriggers() {
  const triggers = document.querySelectorAll('.cart-lineitem-gift-trigger');
  
  triggers.forEach(trigger => {
    // Remove existing listener if any
    const newTrigger = trigger.cloneNode(true);
    trigger.parentNode.replaceChild(newTrigger, trigger);
    
    newTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      
      const itemKey = this.dataset.itemKey;
      console.log('Line item trigger clicked with key:', itemKey);
      
      // Check if we're on the cart page or cart drawer
      const isMainCart = document.querySelector('#main-cart') !== null;
      const isCartDrawer = document.querySelector('cart-drawer') !== null;
      
      if(isCartDrawer) {
        // Cart drawer logic
        const contentInner = document.querySelector('.cart-drawer__footer__content-inner');
        if(contentInner && itemKey) {
          contentInner.dataset.itemKey = itemKey;
          console.log('Set item-key on cart drawer content-inner:', itemKey);
          
          // Fetch cart data and update checkbox states
          fetchCartData().then(cartData => {
            console.log('Cart data fetched:', cartData);
            console.log('Updating checkboxes for item key:', itemKey);
            updateRadioStatesForItemKey(itemKey, cartData);
            updateAllLineItemGiftTitles();
          }).catch(err => {
            console.error('Error in fetchCartData:', err);
          });
        }
        
        // Find the gift wrapping footer action button and click it to open the popup
        const giftWrappingAction = document.querySelector('cart-drawer-footer-action .cart-drawer__footer__action-label');
        console.log('Gift wrapping action button found:', giftWrappingAction);
        
        if(giftWrappingAction) {
          giftWrappingAction.click();
        } else {
          console.error('Gift wrapping action button not found!');
        }
      } else if(isMainCart) {
        // Main cart page logic
        const giftWrappingUpdater = document.querySelector('gift-wrapping-updater');
        if(giftWrappingUpdater && itemKey) {
          giftWrappingUpdater.dataset.itemKey = itemKey;
          console.log('Set item-key on main cart gift-wrapping-updater:', itemKey);
          
          // Fetch cart data and update checkbox states
          fetchCartData().then(cartData => {
            console.log('Cart data fetched:', cartData);
            console.log('Updating checkboxes for item key:', itemKey);
            updateRadioStatesForItemKey(itemKey, cartData);
            updateAllLineItemGiftTitles();
          }).catch(err => {
            console.error('Error in fetchCartData:', err);
          });
        }
        
        // Open the details/accordion
        const giftWrappingDetails = document.querySelector('details[id^="Details-gift-wrapping"]');
        console.log('Gift wrapping details found:', giftWrappingDetails);
        
        if(giftWrappingDetails) {
          giftWrappingDetails.open = true;
          // Scroll to the gift wrapping section
          setTimeout(() => {
            giftWrappingDetails.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 100);
        } else {
          console.error('Gift wrapping details element not found!');
        }
      }
    });
  });
  
  // Monitor when the gift wrapping popup opens to clear item-key if opened directly
  const giftWrappingAction = document.querySelector('cart-drawer-footer-action');
  if(giftWrappingAction) {
    // Use MutationObserver to detect when popup opens
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if(mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isOpen = giftWrappingAction.classList.contains('is-open') || 
                         giftWrappingAction.querySelector('.cart-drawer__footer__action-content.is-open');
          
          if(isOpen) {
            // Check if we have an item-key (opened from line item)
            const contentInner = document.querySelector('.cart-drawer__footer__content-inner');
            if(contentInner && !contentInner.dataset.itemKey) {
              // Opened directly, not from line item
              console.log('Popup opened directly (not from line item)');
            }
          }
        }
      });
    });
    
    observer.observe(giftWrappingAction, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true
    });
  }
  
  // Clear item-key when popup closes (cart drawer)
  const closeButtons = document.querySelectorAll('.cart-drawer__footer__action-close');
  closeButtons.forEach(closeButton => {
    // Add an additional listener to clear item-key (without removing the original close functionality)
    closeButton.addEventListener('click', function() {
      console.log('Close button clicked - clearing item-key');
      
      // Clear the item-key
      const contentInner = document.querySelector('.cart-drawer__footer__content-inner');
      if(contentInner) {
        console.log('Clearing item-key on close');
        delete contentInner.dataset.itemKey;
      }
      
      // The close button already has a listener from cart-drawer-footer-action that calls closeActionContent()
      // So we don't need to manually close it here - it will close automatically
    }, true); // Use capture phase to ensure this runs before the default handler
  });
  
  // Clear item-key when accordion closes (main cart)
  const giftWrappingDetails = document.querySelector('details[id^="Details-gift-wrapping"]');
  if(giftWrappingDetails) {
    giftWrappingDetails.addEventListener('toggle', function() {
      if(!this.open) {
        // Accordion is closing
        console.log('Gift wrapping accordion closed - clearing item-key');
        const giftWrappingUpdater = document.querySelector('gift-wrapping-updater');
        if(giftWrappingUpdater) {
          console.log('Clearing item-key from gift-wrapping-updater');
          delete giftWrappingUpdater.dataset.itemKey;
        }
      }
    });
  }
}

function fetchCartData() {
  return fetch('/cart.js')
    .then(res => res.json())
    .catch(err => {
      console.error('Error fetching cart data:', err);
      return { items: [] };
    });
}

function updateRadioStatesForItemKey(itemKey, cartData) {
  const cartItems = cartData.items || [];
  
  console.log('All cart items:', cartItems);
  
  // Find gift products that have this item-key in their comma-separated keys
  const giftProductsForThisItem = cartItems.filter(item => {
    if(!item.properties || !item.properties._line_item_keys) {
      return false;
    }
    // Check if the item-key is in the comma-separated list
    const keys = item.properties._line_item_keys.split(',');
    return keys.includes(itemKey);
  });
  
  console.log('Gift products for item key', itemKey, ':', giftProductsForThisItem);
  
  // Get all gift wrapping content elements
  const giftWrappingContents = document.querySelectorAll('gift-wrapping-content');
  
  console.log('Found gift wrapping content elements:', giftWrappingContents.length);
  
  giftWrappingContents.forEach(giftContent => {
    const radio = giftContent.querySelector('.gift-wrapping-content__radio');
    if(radio) {
      // Get the gift product ID from the form
      const form = giftContent.querySelector('form');
      const variantIdInput = form ? form.querySelector('input[name="id"]') : null;
      const giftVariantId = variantIdInput ? variantIdInput.value : null;
      
      console.log('Checking gift variant ID:', giftVariantId);
      
      // Check if any gift product matches this variant
      const hasGift = giftProductsForThisItem.some(item => 
        item.variant_id && item.variant_id.toString() === giftVariantId
      );
      
      console.log('Has gift for variant', giftVariantId, ':', hasGift);
      
      // Update radio button state without triggering change event
      const previousValue = radio.checked;
      radio.checked = hasGift;
      
      // Only update if state actually changed to avoid unnecessary events
      if(previousValue !== hasGift) {
        console.log('Radio state changed from', previousValue, 'to', hasGift);
        // Dispatch a custom event to notify about the state change
        radio.dispatchEvent(new CustomEvent('radioStateUpdated', { 
          detail: { checked: hasGift, itemKey: itemKey }
        }));
      }
    }
  });
}

function updateAllLineItemGiftTitles() {
  fetchCartData().then(cartData => {
    const cartItems = cartData.items || [];
    
    console.log('=== Updating gift titles for all line items ===');
    console.log('Cart items:', cartItems);
    
    // Get all line item gift title containers
    const giftTitleContainers = document.querySelectorAll('.cart-lineitem-selected-gift-title');
    console.log('Found gift title containers:', giftTitleContainers.length);
    
    giftTitleContainers.forEach((container, index) => {
      const itemKey = container.dataset.itemKey;
      
      console.log(`Container ${index}: item key =`, itemKey);
      
      if(!itemKey) {
        console.log('No item key found for gift title container');
        return;
      }
      
      // Find gift products that have this item-key in their comma-separated keys
      const giftProductsForThisItem = cartItems.filter(item => {
        if(!item.properties || !item.properties._line_item_keys) {
          return false;
        }
        const keys = item.properties._line_item_keys.split(',');
        return keys.includes(itemKey);
      });
      
      console.log('Gift products for item key', itemKey, ':', giftProductsForThisItem);
      
      // Update the display
      if(giftProductsForThisItem.length > 0) {
        // Get the first gift product title (assuming one gift per line item)
        const giftTitle = giftProductsForThisItem[0].product_title || giftProductsForThisItem[0].title;
        container.textContent = `* ${giftTitle}`;
        container.style.display = '';
        console.log('✓ Updated gift title for item key', itemKey, ':', giftTitle);
      } else {
        // No gift selected, hide the container
        container.textContent = '';
        container.style.display = 'none';
        console.log('✗ No gift for item key', itemKey, '- hiding title');
      }
    });
  }).catch(err => {
    console.error('Error updating gift titles:', err);
  });
}